import React from "react";
import Avatar from "../core/view/Avatar";
import clsx from "clsx";
import {useStudentLogin, Student} from "./hooks/useStudentLogin";
const styles = require("./styles/TopBar.css");

interface ImitateStudentLinkProps {
	student: Student;
	onClick?: () => void;
	avatarClassName?: string;
	method?: string;
}

interface RegisteredStudentLinkProps {
	student: Student;
	onClick: () => void;
	avatarClassName?: string;
}

interface UnregisteredStudentLinkProps {
	student: Student;
	onClick: () => void;
	avatarClassName?: string;
}

const RegisteredStudentLink = ({
	student,
	onClick,
	avatarClassName,
}: Omit<RegisteredStudentLinkProps, "method"> & {onClick: () => void}) => {
	return (
		<div className={styles.playLink} onClick={onClick}>
			<Avatar
				className={clsx(styles.msLinkAvatar, avatarClassName)}
				avatar={student.avatarData}
				hasRing={true}
			/>
			<div>
				<div>{student.displayName}</div>
				<div className={styles.username}>{student.username ?? null}</div>
			</div>
		</div>
	);
};

const UnregisteredStudentLink = ({
	student,
	onClick,
	avatarClassName,
}: Omit<UnregisteredStudentLinkProps, "method"> & {onClick: () => void}) => {
	return (
		<div className={styles.playLinkDisabled} onClick={onClick}>
			<Avatar
				className={clsx(styles.msLinkAvatar, avatarClassName)}
				avatar={student.avatarData}
				hasRing={true}
				fallbackDisplayName={student.displayName}
			/>
			<div>
				{student.displayName}
				<div className={styles.username}>Set up account</div>
			</div>
		</div>
	);
};

export const ImitateStudentLink = ({
	student,
	onClick,
	avatarClassName,
	method = "generic",
}: ImitateStudentLinkProps) => {
	const {handleClick, isRegistered} = useStudentLogin(student, method);

	// Use custom onClick if provided, otherwise use the hook's handleClick
	const finalOnClick = onClick || handleClick;

	if (isRegistered) {
		return (
			<RegisteredStudentLink
				student={student}
				onClick={finalOnClick}
				avatarClassName={avatarClassName}
			/>
		);
	} else {
		return (
			<UnregisteredStudentLink
				student={student}
				onClick={finalOnClick}
				avatarClassName={avatarClassName}
			/>
		);
	}
};

export default ImitateStudentLink;
